import type { Product } from "@/contexts/product-context"

/**
 * Sign-in flow + States profile rows for the Exam Management prototype deploy.
 * Builder workspaces keep them via authoring; production Cloudflare demo keeps
 * them when the active product is Exam Management.
 */
export function examManagementProfilePrototypeMenuEnabled(
  product: Product,
  authoringEnabled: boolean,
): boolean {
  return authoringEnabled || product === "exxat-exam-management"
}
